<!-- 顶部公告：顾兴明接口数据 -->
<template>
  <div v-if="announceList.length" class="announce-box">
    <div v-for="(item, index) in showList" :key="index" class="tip-item" @click="$">
      <p class="tip-content"><span
        v-for="(word, wordIndex) in item.showContent"
        :key="wordIndex"
        :class="word.styleType"
        >{{word.content}}</span></p>
      <img v-if="item.mode === 3" :src="closeIcon" class="close-icon"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'config-announce',

  props: {
    fundCode: {
      type: String,
      default: '',
    },
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    pageConfig: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      // 关闭按钮
      closeIcon:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAvVJREFUWEfNl0trE2EUht+TpElaSVtrLbVYraKF2lKkiiAiUnQhdtGVC3Xjxn+gv0A31V8hVARdKoKXhSBCBRfWTJJaBcVCZkpjqraYmSTzHfmmJsYmmXyTNjGzPpdn3nOboUwyymjkQ7RMjHkivAH5HwYTRoImJ/PVUlLDgTZlJkKOQdfC/aOzRGRvBms6UAGAiPSQHxPUN2aUQv03IAlBBNvnp+PBvrF3RdBml6ysRAQ75Ke9BaX+q0L/lK9/dFD2VEsAOWBEV9v3jN1tGSA5faGFVEfLAEmRfL7AeGsBEd1sKSACPfMEtPppDixy6D54Ar5AyPXgZFJfsK5/QNfQMQQjvWrHSZ4ZL3sovfgK2fU0AuEIeoZPVYX6tfIZP5feOxA9h04i2NmnBiSHzUxqFoODKh4ibyG9+Bp5c60qVClM5+A4OnYfUAldtKFMUksBvEvVyw1qqzDOOjKT2iKDD6sCSbtKUOZqslimepQpbm1Tjz5mxpQXoM1QvrYwRM50QmwFZkMhXbvNzDe8AhWgUomXRZjIwBHs6PckdllayhixsxDiRT1ApT0j/WtNn0oOYuaApWsrDHSrOBRsSmGkMpn0kuv0qcYmaZhJRmcBXFF1qjRNKitBJb4DZOmxi4LFAxUHt9HeDigHiFkLWgYvMMN1i8lz8OPrvOs0lUOdhi/QpvKujo0D5KhkxC4LIe65ea5En8LOmTVHuxSqa99RtPfu9w7EzGTp2lsGJqp5Z9fkUhdKt0nkc7C+JxHeOQDy16GQ09xG/ByE/Vz5dRpgWCxZIbapx+4wi+sNyKUUsgyImX2WoT1ixgWlCNtsVAbkTN23j51W1ppj5pFtzlczXEUgp5/0xBDBftJsqKpAf5Uy7zezfK5AG0tT9lR8plmNXhOoUHS5EkjYM257qmaDKBgoA/1Ri7LL8UvM4latM6OQu6KJJ6BCBHn7sgZNCxbTBEx5/XRxg60LqDSg/J4yl+NniHEeECNgGmagh4CI6t9Mabzfz7OsPa0av2EAAAAASUVORK5CYII=',
    };
  },

  computed: {
    announceList() {
      const list = this.pageConfig?.announcementConfig || [];
      let announcementConfig = [];
      if (this.basicInfo?.isNewFund) {
        announcementConfig = list.filter((item) => item.fundType === '4');
      } else if (this.basicInfo?.isCurrencyFund) {
        announcementConfig = list.filter((item) => item.fundType === '2');
      } else if (this.basicInfo?.isETF) {
        announcementConfig = list.filter((item) => item.fundType === '3');
      } else {
        announcementConfig = list.filter((item) => item.fundType === '1');
      }
      const finalList = announcementConfig.map((item) => {
        const excludeCodes = item.excludeCodes || [];
        const includeCodes = item.includeCodes || [];
        // 包含
        if (includeCodes.length) {
          if (includeCodes.indexOf(this.fundCode.toLowerCase()) > -1) {
            return item;
          }
        } else if (item.fundType !== '5' && item.fundType !== '6') {
          // 类型
          // 不包含
          if (excludeCodes.indexOf(this.fundCode.toLowerCase()) < 0) {
            return item;
          }
        }
        return {};
      })?.filter((item) => !this.$isEmpty(item));
      return finalList;
    },
    showList() {
      const configList = this.announceList || [];
      const showList = configList.map((config) => {
        const content = config.content || '';
        const hotKeys = config.hotKey || [];
        let tmpContent = content;
        hotKeys.forEach((hotKey) => {
          tmpContent = tmpContent.replace(hotKey, `||${hotKey}||`);
        });
        const strArr = tmpContent.split('||');
        const finalArr = strArr.map((str) => ({
          content: str,
          styleType: hotKeys.includes(str) ? 'hotkey' : 'normal',
        }));
        return { ...config, showContent: finalArr };
      });
      return showList || [];
    },
  },

};
</script>

<style lang="less" scoped>
.announce-box {
  width: 100%;
  position: relative;
}
.tip-item {
  margin-bottom: 24px;
  padding: 24px;
  background-color: #FFFDEB;
  border: 1px solid #FFE780;
  border-radius: 12px;
  display: flex;
}
.tip-content {
  margin: 0;
  display: inline;
  font-size: 28px;
  line-height: 0;
}
.normal {
  color: #333333;
  font-size: 28px;
  line-height: 42px;
  font-weight: 500;
}
.hotkey {
  color: #3A90FA;
  font-size: 28px;
  line-height: 42px;
  font-weight: 500;
}
.close-icon {
  position: absolute;
  right: 0;
  top: 0;
  height: 36px;
  width: 36px;
}
</style>
